<script>
import _ from 'lodash'
import { DDMMYYYYSlashSeparated } from '@/filters/date'
import ReferralService from '@/services/referralService'
import { microbaLoader, microbaSuccess, microbaFailure } from '@microbadevs/notifications'

export default {
  name: 'Referrals',
  filters: {
    DDMMYYYYSlashSeparated
  },
  data () {
    return {
      referralSearch: '',
      selected: 'unactioned',
      options: [
        { text: 'Unactioned', value: 'unactioned' },
        { text: 'Actioned', value: 'actioned' }
      ],
      sortedBy: 'name',
      order: 'asc',
      referralsData: null
    }
  },
  computed: {
    formattedReferrals () {
      return this.referralsData && this.referralsData.length > 0
        ? this.referralsData.map(referral => {
          return {
            name: `${referral.patient.firstName} ${referral.patient.lastName}`,
            referralDate: referral.createdDate,
            email: referral.patient.email,
            ...referral
          }
        }) : []
    },
    referrals () {
      const keyword = this.referralSearch.toLowerCase()
      const filteredReferrals = this.formattedReferrals && this.formattedReferrals.length > 0
        ? this.formattedReferrals.filter(referral => {
          return String(referral.name).toLowerCase().includes(keyword) || String(referral.email).toLowerCase().includes(keyword)
        }) : []
      const selectedReferrals = this.selected === 'actioned'
        ? filteredReferrals.filter(referral => {
          return referral.orderId && referral.orderId !== null
        })
        : filteredReferrals.filter(referral => {
          return referral.orderId === null
        })
      return _.orderBy(selectedReferrals, [this.sortedBy], [this.order])
    }
  },
  mounted () {
    this.getReferrals()
  },
  methods: {
    sortBy (col) {
      if (this.sortedBy === col) {
        this.order = this.order === 'desc' ? 'asc' : 'desc'
      } else {
        this.sortedBy = col
        this.order = 'asc'
      }
    },
    sendRemind (referral) {
      microbaLoader.showLoader()
      this.$store.dispatch('invitePatient', referral)
        .then(response => {
          microbaSuccess({ text: 'Reminder has been successfully sent.' })
        }).catch(error => {
          microbaFailure({ text: `Unable to send reminder. Error: ${error}` })
        })
    },
    getReferrals () {
      ReferralService.getReferrals().then(response => {
        this.referralsData = response.data
      })
    }
  }
}
</script>

<template>
  <div
    class="container py-5"
    style="min-height: 55vh"
  >
    <div class="row">
      <div class="col-9">
        <h2>Referrals</h2>
      </div>
      <div class="col-3">
        <input
          v-model="referralSearch"
          class="float-right form-control form-control-sm"
          placeholder="Search Referrals"
        >
      </div>
    </div>
    <div class="row d-flex justify-content-end">
      <b-form-group>
        <b-form-radio-group
          v-model="selected"
          :options="options"
        />
      </b-form-group>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>
            <a
              href="#"
              @click.prevent="sortBy('name')"
            >Patient Name</a>
          </th>
          <th>
            <a
              href="#"
              @click.prevent="sortBy('referralDate')"
            >Referral Date</a>
          </th>
          <th>Patient Email</th>
          <th v-if="selected === 'unactioned'">
            Actions
          </th>
          <th v-if="selected === 'actioned'">
            Order ID
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="referrals && referrals.length > 0">
          <tr
            v-for="referral in referrals"
            :key="referral.id"
          >
            <td>{{ referral.name }}</td>
            <td>{{ referral.referralDate | DDMMYYYYSlashSeparated }}</td>
            <td>{{ referral.email }}</td>
            <td v-if="selected === 'unactioned'">
              <a
                href="#"
                @click.prevent="sendRemind(referral)"
              >Send Reminder</a>
            </td>
            <td v-if="selected === 'actioned'">
              {{ referral.orderId }}
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td
              colspan="5"
              class="text-center"
            >
              You don't currently have any referrals.
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
